<template>
  <!-- 活动详情 -->
  <div class="page-activity-detail">
    <div class="g-content-wrap">
      <div class="intro g-card-2">
        <div class="pic-box">
          <img v-lazy="detailData.picUrl" alt="">
          <!-- 0-报名中 2-已结束 1-已报满 -->
          <span class="g-status" v-if="detailData.activityStatus==='0'"><i></i>报名中</span>
          <span class="g-status g-status-end" v-if="detailData.activityStatus==='2'"><i></i>已结束</span>
          <span class="g-status g-status-full" v-if="detailData.activityStatus==='1'"><i></i>已报满</span>
        </div>
        <div class="g-border-box white">
          <div class="g-border">
            <span class="g-bor-dec g-bor-dec-1"></span>
            <span class="g-bor-dec g-bor-dec-2"></span>
            <span class="g-bor-dec g-bor-dec-3"></span>
            <span class="g-bor-dec g-bor-dec-4"></span>

            <div class="item-info">
              <h2 class="act-title ell">{{detailData.activityName}}</h2>
              <!-- <p>活动类型：{{detailData.typeName}}</p> -->
              <p>活动时间：{{detailData.activityTime}}</p>
              <p>
                <span>活动地点：{{detailData.activityPlace}}</span>
                <span class="ml-30">要求：{{detailData.requirement}}</span>
              </p>
              <!-- <p class="price mt-20">费用：<span class="val"><i>1245</i>元</span></p> -->

              <p class="price mt-20">名额：<span class="val">{{detailData.freeQuota}}</span></p>
              <p class="price mt-20">费用：<span class="val"><i>{{detailData.price}}</i></span></p>
              <div class="num-remain">
                <!-- 0-报名中 2-已结束 1-已报满 -->
                <!-- <div class="num-process">
                  <div class="process">
                    <el-progress :percentage="50" :show-text="false" color="#CCA176" v-if="detailData.activityStatus==='0'"></el-progress>
                    <el-progress :percentage="50" :show-text="false" color="#999493" v-if="detailData.activityStatus==='2'"></el-progress>
                    <el-progress :percentage="50" :show-text="false" color="#995314" v-if="detailData.activityStatus==='1'"></el-progress>
                  </div>
                  <p>已报名：{{detailData.peopleNum}}人</p>
                </div>
                <div class="num tc">
                  <p class="num-val">{{detailData.freeQuota}}</p>
                  <p>剩余名额</p>
                </div> -->
                
                <div class="code-box tc">
                  <img :src="detailData.qrcodeUrl" alt="">
                  <p>请扫描二维码在手机上报名</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <cmpTitle title="活动详情" class="mb-40"></cmpTitle>
      <div class="g-detail-html trans" v-html="detailData.content"></div>

      <cmpTitle class="mt-40" title="报名公示"></cmpTitle>
      <div class="persons-list mt-40">
        <div class="person-item" v-for="(item, index) in viewList" :key="index">
          <img :src="item.imgUrl" alt="" :onerror="defaultHeadImg">
          <p class="name ell mt-5">{{item.userName}}</p>
          <p class="time mt-5">{{item.times}}</p>
        </div>
      </div>
      <div class="btn-show mt-2 mt-md-7 tc" @click="toggleShow" v-if="detailData.users && detailData.users.length > showLen">
      <!-- <div class="btn-show mt-2 mt-md-7 text-center" @click="toggleShow" v-if="viewList.length > showLen"> -->
        <a>{{showAll ? '收起' : '展开所有报名'}} <i :class="showAll?'el-icon-arrow-up':'el-icon-arrow-down'"></i></a>
      </div>

      <!-- 无数据 -->
      <div class="g-no-data" v-if="detailData.users && detailData.users.length === 0 && !listLoading" style="padding-top:0;">
        <div class="no-data-bg"></div>
        <p class="txt text-center">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
export default {
  components: { cmpTab },
  data() {
    return {
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      detailId: this.$route.query.id,
      activeVal: '2',
      tabList: [
        {
          name: '展厅实景',
          val: '1'
        },
        {
          name: '展品详情',
          val: '2'
        }
      ],
      detailData: {},

      viewList: [],
      listLoading: false,
      showAll: false,
      showLen: 11
    }
  },
  methods: {
    getDetailData() {
      this.listLoading = true
      this.$http
        .get('/activity/getActivityById.do', {
          activityId: this.detailId
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.detailData = res.data
            this.viewList = this.detailData.users.slice(0, this.showLen)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    toggleShow() {
      this.showAll = !this.showAll
      if(this.showAll) {
        this.viewList = this.detailData.users
      } else {
        this.viewList = this.detailData.users.slice(0, this.showLen)
      }
    }
  },
  created() {
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-detail {

  .g-card-2 {
    cursor: initial;
    &:hover {
      .pic-box {
        img {
          transform: none;
        }
      }
    }
  }

  .intro {
    .pic-box {
      width: 432px;
      img {
        width: 432px;
        height: 270px;
      }
    }
    .item-info {
      background: #fff;
      font-size: 14px;
      line-height: 26px;
      color: #45443E;
      h2 {
        margin-bottom: 12px;
        font-size: 22px;
        color: #45443E;
        line-height: 32px;
      }
      .num-remain {
        padding-right: 180px;
        margin-top: 20px;
        display: flex;
        font-size: 14px;
        color: #999493;
        .num {
          width: 80px;
          .num-val {
            font-size: 26px;
            line-height: 30px;
            color: #292423;
          }
        }
        .num-process {
          padding-top: 32px;
          position: relative;
          flex: 1;
          .progress-2 {
            display: none;
          }
          p {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        
      }

      .price {
        .val {
          font-size: 20px;
          i {
            color: $primary;
          }
        }
      }

      
      .code-box {
        margin-left: 10px;
        position: absolute;
        right: 20px;
        bottom: 20px;
        color: $primary;
        font-size: 14px;
        img {
          width: 100px;
          height: 100px;
          margin-bottom: 8px;
        }
      }

    }
  }

  .persons-list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
    .person-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 109px;
      padding: 13px 0;
      font-size: 14px;
      color: #292423;
      // background: #fff;
      img {
        width: 52px;
        height: 52px;
      }
      .name {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        text-align: center;
      }
      .time {
        color: #999493;
      }
      &:nth-child(2n) {
        background: rgba(178,149,81,0.16);
      }
    }
  }

  .btn-show {
    margin-top: 10px;
    a {
      color: #292423;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>

